import React, { useEffect, useMemo, useState } from 'react'
import { Col, Row } from 'react-bootstrap';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Card from '../../UI/Card/Card';
import Graybg from '../../UI/Graybg';
import SecBTN from '../../UI/SecBTN';
import classes from './EditPaper.module.css'
import { Link } from 'react-router-dom';
import userService from '../../app/services/user.service';
import { toast } from 'react-toastify';
import Loader from '../../UI/loader/loader';
import { isEmpty } from '../../utils/custom_funtions';
import SmallLoader from '../../UI/SmallLoader/SmallLoader';
import SearchInput from '../../UI/SearchInput/SearchInput';


const EditPaper = () => {
  const user_id = JSON.parse(localStorage.getItem("user"))?.data?.user?.user_id;
  const [loading, setLoading] = useState(false);
  const [pendingData, setPendingData] = useState([]);
  const [pageNo, setPageNo] = useState(0);
  const [search, setSearch] = useState('');
  const listCount = 50;
  const pendingPaperFn = () => {
    setLoading(true)
    userService
      .getReqpaperList()
      .then((data) => {
        // if (data.data.data.length < 50) {
        //   setloadMore(false);
        // }
        setLoading(false);
        // setPendingData(data.data.data);
        // console.log([...data.data.data[0]])
        let datas = data.data.data[0]
        let newArr = [];
        for (const i in datas) {
          if (datas[i].status == 1) {
            const object = datas[i];
            newArr.push(object)
          }
        }
        setPendingData(newArr)
        console.log(newArr)
      })
      .catch((error) => {
        setLoading(false);
        console.log("error", error);
        toast.error(error.message);
      });
  };
  useEffect(() => {
    pendingPaperFn();
  }, []);

  const searchedData = useMemo(() => {
    // let computedData = pendingData;
    if (search) {
      return pendingData.filter(data => data.paper_name.toLowerCase().includes(search.toLowerCase()))
    } else {
      return pendingData
    }
  }, [search, pendingData]);

  return (
    <div className="section">
      {loading && <Loader />}
      <div className="d-flex flex-column flex-md-row justify-content-start justify-content-md-between align-items-start align-items-md-center">
        <div>
          <h4>Edit Paper</h4>
          <Breadcrumb>
            <Breadcrumb.Item active>Edit Paper</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className='d-flex gap-3 align-items-center mb-3'>
          <SearchInput value={search} onChange={e => setSearch(e.target.value)} />
          <div className={`d-flex justify-content-center align-items-center gap-3 ${classes.btnsec}`}>
            <SecBTN className='sec-btn me-0' disabled={pageNo == 0} onClick={() => setPageNo(pageNo - 1)}><i className="fa-solid fa-arrow-left"></i></SecBTN>
            <p style={{ width: "60px" }} className='text-center' > {`${Math.ceil(searchedData.length / 50) == 0 ? 0 : pageNo + 1} / ${Math.ceil(searchedData.length / 50)}`}
            </p>
            <SecBTN className='sec-btn' disabled={pageNo + 1 == Math.ceil(searchedData.length / 50) || Math.ceil(searchedData.length / 50) == 0} onClick={() => setPageNo(pageNo + 1)}><i className="fa-solid fa-arrow-right"></i></SecBTN>
          </div>
        </div>
      </div>
      <Graybg>
        {
          isEmpty(searchedData) ? (
            !loading &&
            <p className="text-center">No data available.</p>
          ) : (
            searchedData.slice(listCount * pageNo, (pageNo + 1) * listCount).map((data, i) => (
              <Card>
                <Row>
                  <Col lg={10} md={8} sm={12}>
                    <h5>
                      {data.paper_name}
                    </h5>
                    <Row>
                      <Col lg={8} md={6} sm={12}>
                        <p><strong>Class : </strong> {data.class}</p>
                        {/* <p>Subject : {props.subject}</p> */}
                        <p><strong>Target :</strong> {data.target}</p>
                        <p><strong>Format : </strong>{data.format}</p>
                        <p><strong>Questions Assigned by :</strong> {data.creator}</p>
                      </Col>
                      <Col lg={4} md={6} sm={12}>
                        <p><strong>Assigned on :</strong> {new Date(data.created_on).toLocaleDateString("sv-SE")}</p>
                        <p><strong>Exam Date : </strong>{data.to_be_held_on}</p>
                        <p><strong>Date Of Submission : </strong> {data.to_be_completed_by}</p>
                      </Col>
                    </Row>
                  </Col>
                  <Col lg={2} md={4} sm={12} className="text-end">
                    <Link to={`/editPaper/${data.pid}`}>
                      <SecBTN className={classes["delpaper-btn"]}>
                        Edit paper
                      </SecBTN>
                    </Link>
                  </Col>
                </Row>
              </Card>
            )
            )
          )
        }
      </Graybg>
    </div>
  );
}

export default EditPaper;
